/**
 * MarcasConfirmacion — GEN-TL-009: junto al texto del nivel concedido, la marca
 * «Pide confirmación» (GEN-TL-005/030) de los niveles que la piden entre los que
 * tiene el agente (el concedido y los incluidos). Un solo nivel: la marca sola, como antes.
 */
export default function MarcasConfirmacion({ niveles, nombre }) {
  const piden = (niveles ?? []).filter(n => n.pide_confirmacion)
  if (piden.length === 0) return null
  const solo = (niveles ?? []).length === 1
  return (
    <ul className="equipo-card__chips" aria-label={`Confirmación de ${nombre}`}>
      {piden.map(n => (
        <li key={n.clave_recurso} className="equipo-chip equipo-chip--confirmacion">
          {solo ? 'Pide confirmación' : `${n.nombre.split(' ')[0]} · pide confirmación`}
        </li>
      ))}
    </ul>
  )
}
